import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import DinBilpartnerBadge from '../components/DinBilpartnerBadge'
import ReviewsSlider from '../components/ReviewsSlider'
import ContactForm from '../components/ContactForm'
import { imageUrl } from '../lib/images'

export default function ServiceeftersynPage({ settings }) {
  const bookingUrl = settings?.booking_url || 'https://service.dinbilpartner.dk/book-tid'
  const phone = settings?.phone || '22 18 73 30'
  const phoneRaw = settings?.phone_raw || '22187330'

  return (
    <>
      <MetaTags
        title="Serviceeftersyn | Serviceeftersyn af bil nær Billund og Grindsted"
        description="Hos EK Biler udfører vi serviceeftersyn på alle biler. Uanset mærke. model eller en elbil kan vi hjælpe. Besøg i Hejnsvig nær Billund og Grindsted"
        ogTitle="Serviceeftersyn | Serviceeftersyn af bil nær Billund og Grindsted"
        ogDescription="Hos EK Biler udfører vi serviceeftersyn på alle biler. Uanset mærke. model eller en elbil kan vi hjælpe. Besøg i Hejnsvig nær Billund og Grindsted"
        ogImage={imageUrl('shutterstock-2258342797-optimized-1.jpg', 'width=1200,quality=85,format=auto')}
      />

      {/* Hero Header */}
      <section className="bg-[#14171a] text-white py-14 sm:py-20 border-b border-[#262c33] relative overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-20">
          <img
            src={imageUrl('shutterstock-2258342797-optimized-1.jpg', 'width=1600,quality=80,format=auto')}
            alt="Serviceeftersyn af bil"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
          <div className="max-w-3xl space-y-4">
            <div className="flex items-center gap-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
              <Link to="/" className="hover:text-white">Forside</Link>
              <span>/</span>
              <span className="text-[#e20019]">Autoværksted</span>
            </div>
            <h1 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white">
              Serviceeftersyn
            </h1>
            <p className="text-gray-300 text-base sm:text-lg leading-relaxed">
              Professionel service og reparation og skader af alle bilmærker. Speciale i V.A.G
              Gruppen (VW, Audi, Seat, Skoda) og altid mulighed for lånebil, når din bil er på
              værksted.
            </p>
            <div className="pt-2 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white px-6 py-3 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-red-500 text-center"
              >
                <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                <span>Book tid til service</span>
              </a>
              <a
                href={`tel:${phoneRaw}`}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#20252c] hover:bg-[#2b323c] border border-gray-700 text-white px-5 py-3 rounded-xl font-bold text-sm transition-colors whitespace-nowrap text-center"
              >
                <i className="fa-solid fa-phone text-[#e20019]" aria-hidden="true" />
                <span>Ring på {phone}</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content from Scrape */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            {/* Left Column: Verbatim Content */}
            <div className="lg:col-span-7 space-y-8 text-gray-800 leading-relaxed text-base">
              <div>
                <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                  Serviceeftersyn hos EK Biler
                </h2>
                <p>
                  Hos EK Biler nær Billund og Grindsted tilbyder vores autoværksted professionelle
                  serviceeftersyn til alle typer biler, uanset mærke eller model. Et serviceeftersyn
                  er vigtigt for at holde din bil i topform og undgå uforudsete problemer på vejene.
                  Når din bil kommer til service hos os, foretager vi en grundig gennemgang, der kan
                  omfatte:
                </p>
                <ul className="list-disc list-inside space-y-2 mt-4 pl-2 text-gray-700">
                  <li>Kontrol af motorolie og oliefilter</li>
                  <li>Gennemgang af bremser og dæk</li>
                  <li>Tjek af batteri, lygter og elektriske systemer</li>
                  <li>Inspektion af væsker, herunder kølervæske, bremsevæske og sprinklervæske</li>
                </ul>
                <p className="mt-4">
                  Vi undersøger bilen fra bund til top, så du er køreklar. Kontakt os allerede i dag
                  for at høre mere!
                </p>
              </div>

              <div className="bg-red-50/50 p-6 rounded-2xl border border-red-100 space-y-3">
                <h3 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                  <i className="fa-solid fa-bolt text-[#e20019]" aria-hidden="true" />
                  <span>Vi servicerer også elbiler!</span>
                </h3>
                <p className="text-sm text-gray-700 leading-relaxed">
                  Hvis du er ejer af en elbil, kan du trygt tage kontakte til os. Vi udfører nemlig
                  serviceeftersyn på alle typer biler – også elbiler. Vi har det rette udstyr og
                  ekspertisen til at sikre, at din elbil får et grundigt tjek, så den fungerer
                  optimalt. Der findes ikke en biltype, som vi ikke kan håndtere. Vi kan også hjælpe
                  dig med <Link to="/elbil-service" className="text-[#e20019] font-bold hover:underline">elbil service</Link> så din bil for optimal drift og længere levetid.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Hvorfor er et serviceeftersyn nødvendigt?
                </h2>
                <p>
                  At få foretaget et regelmæssigt serviceeftersyn er afgørende for din bils levetid og
                  din egen sikkerhed. Her er nogle gode grunde til at overholde serviceeftersyn:
                </p>
                <div className="space-y-4 mt-4">
                  <div className="border-l-4 border-[#e20019] pl-4">
                    <strong className="block text-gray-900">Forebyggelse af større skader:</strong>
                    <span className="text-sm text-gray-600">
                      Til et serviceeftersyn kan vi opdage små problemer, inden de udvikler sig til
                      dyre reparationer.
                    </span>
                  </div>
                  <div className="border-l-4 border-[#e20019] pl-4">
                    <strong className="block text-gray-900">Forlængelse af bilens levetid:</strong>
                    <span className="text-sm text-gray-600">
                      En velholdt bil holder længere og bevarer sin værdi bedre.
                    </span>
                  </div>
                  <div className="border-l-4 border-[#e20019] pl-4">
                    <strong className="block text-gray-900">Øget sikkerhed:</strong>
                    <span className="text-sm text-gray-600">
                      Ved at kontrollere bremser, dæk og andre vigtige systemer sikrer vi, at din bil
                      er sikker at køre i.
                    </span>
                  </div>
                </div>
                <p className="mt-4 text-sm text-gray-700">
                  Herudover kan manglende serviceeftersyn have konsekvenser for din bils garanti og
                  gensalgsværdi. Når bilen bliver serviceret, dokumenteres det i servicebogen, hvilket
                  viser kommende købere, at bilen er blevet vedligeholdt korrekt. Hos EK Biler gør vi
                  det let at holde styr på bilens stand og historik med professionelle
                  serviceeftersyn.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-3">Tid til service?</h2>
                <p>
                  Du spørger måske dig selv, hvornår og hvor ofte bilen skal til serviceeftersyn?
                  Serviceeftersyn afhænger typisk af bilens alder og kørte kilometer. Som
                  tommelfingerregel anbefales et eftersyn én gang om året eller for hver 15.000-30.000
                  kilometer. For nyere biler kan producentens anbefalinger variere, hvorfor vi gerne
                  hjælper dig med at finde det rette tidspunkt.
                </p>
              </div>

              {/* Photo break */}
              <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-sm">
                <img
                  src={imageUrl('shutterstock-2258342797-optimized-1.jpg', 'width=800,quality=80,format=auto')}
                  alt="udførsel af serviceeftersyn på bil"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Der findes to typer serviceeftersyn
                </h2>
                <div className="space-y-4">
                  <div className="bg-gray-50 p-5 rounded-xl border border-gray-200">
                    <h3 className="font-bold text-gray-900 text-lg mb-1">Lille serviceeftersyn</h3>
                    <p className="text-sm text-gray-600">
                      Her tjekker vi de mest essentielle dele af bilen, som olie og filtre, bremser og
                      lys. Det er en god mulighed for at sikre, at bilen kører sikkert og effektivt.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-xl border border-gray-200">
                    <h3 className="font-bold text-gray-900 text-lg mb-1">Stort serviceeftersyn</h3>
                    <p className="text-sm text-gray-600">
                      Dette inkluderer en mere omfattende gennemgang af bilen, hvor vi tjekker flere
                      komponenter og udskifter dele efter behov. Det er typisk nødvendigt for biler, der
                      har kørt længere eller kræver ekstra opmærksomhed.
                    </p>
                  </div>
                </div>
                <p className="mt-4 text-sm text-gray-700">
                  Hos EK Biler sørger vi altid for, at serviceeftersynet passer til din bil og dens
                  behov. Prisen på et serviceeftersyn varierer afhængigt af biltype og omfanget af
                  eftersynet. Et lille serviceeftersyn vil naturligvis være billigere end et stort.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Ærlig rådgivning</h3>
                <p>
                  Som dit autoværksted nær Billund og Grindsted vægter vi gennemsigtighed og ærlighed
                  højt. Vi giver dig en klar pris og forklaring på, hvad der skal udføres, inden vi går
                  i gang. På den måde er du altid informeret om forløbet og kan føle dig tryg ved vores
                  service. Kontakt os for en uforpligtende snak om din bil – så finder vi den bedste
                  løsning for dig.
                </p>
              </div>
            </div>

            {/* Right Column: Sticky Booking Card & Contact Form */}
            <div className="lg:col-span-5 space-y-6 lg:sticky lg:top-24">
              <div className="bg-[#14171a] text-white p-6 sm:p-8 rounded-2xl border border-gray-800 space-y-4">
                <div className="text-xs font-bold text-[#e20019] uppercase tracking-wider">
                  Online Tidsbestilling
                </div>
                <h3 className="text-2xl font-bold">Bestil serviceeftersyn</h3>
                <p className="text-sm text-gray-300">
                  Vælg tidspunkt online på vores direkte bookingsystem, eller send os en forespørgsel
                  nedenfor.
                </p>
                <div className="pt-2">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full text-center inline-flex items-center justify-center gap-2 bg-[#e20019] hover:bg-[#b80014] text-white py-3.5 px-6 rounded-xl font-bold text-sm shadow-md transition-all whitespace-nowrap"
                  >
                    <i className="fa-solid fa-calendar-check" aria-hidden="true" />
                    <span>Book tid hos Din Bilpartner</span>
                  </a>
                </div>
              </div>

              {/* Form from scrape: "Send en forespørgsel / Vi vender tilbage for at fuldføre din booking" */}
              <ContactForm
                title="Send en forespørgsel"
                subtitle="Vi vender tilbage for at fuldføre din booking"
                bookingUrl={bookingUrl}
              />
            </div>
          </div>
        </div>
      </section>

      <DinBilpartnerBadge />
      <ReviewsSlider />
    </>
  )
}
